var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticStyle:{"text-align":"center"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","lg":"12"}},[_c('img',{staticClass:"header-brand-img-alert",attrs:{"src":_vm.imagen,"alt":"logo"}}),_c('label',{staticClass:"label-negrita"},[_vm._v(_vm._s(_vm.msj))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }